module.exports = __webpack_public_path__ + "static/media/ABOUT4.f75c171c.jpg";